/**
 * A barra de consulta — a porta de VOLTA do fio.
 *
 * ## O problema que ela resolve (relato do TL, 13/Ago/2026)
 *
 * O banner âmbar do fio vive FORA da área de rolagem, então está sempre à mão.
 * Mas quando o fio desligava, ele sumia — e o único caminho de volta era um link
 * pequeno DENTRO da rolagem, no topo do histórico. Ou seja: para voltar, o
 * operador tinha que subir o histórico inteiro.
 *
 * Esta barra ocupa o mesmo lugar e o mesmo tom do banner do fio, e nunca foge da
 * tela. É a única coisa acionável numa conversa que já acabou.
 *
 * ## Por que ela não oferece mais nada
 *
 * Foi decisão explícita do TL, e eu concordo: numa conversa encerrada não há o
 * que fazer. Reabrir já está restrito à mais recente da pessoa; «favoritar» não
 * tem caso de uso. A única candidata que sobrevive ao teste é «trazer algo desta
 * para a conversa viva» — e ela fica no banco até existir um operador pedindo,
 * não uma sessão deduzindo.
 */
export function ConsultaDeEpisodioBanner({
  rotuloDoEpisodio,
  nomeDaPessoa,
  onVoltar,
}: {
  /** «07/08 · troca de plano» — o MESMO rótulo da oferta que trouxe até aqui. */
  rotuloDoEpisodio: string | null;
  nomeDaPessoa: string | null;
  onVoltar: () => void;
}): JSX.Element {
  return (
    <div
      data-testid="consulta-banner"
      role="status"
      className="flex items-center gap-2 px-4 py-1.5 text-xs"
      style={{ background: 'var(--brand-subtle)', color: 'var(--brand-subtle-fg)' }}
    >
      <span aria-hidden>⚡</span>
      <span>
        Consultando{' '}
        {rotuloDoEpisodio !== null ? (
          <>
            a conversa de <strong>{rotuloDoEpisodio}</strong>
          </>
        ) : (
          <strong>uma conversa anterior</strong>
        )}{' '}
        — somente leitura
      </span>
      <span className="flex-1" />
      <button type="button" data-testid="voltar-ao-fio" onClick={onVoltar} className="underline">
        ← voltar pro fio{nomeDaPessoa !== null ? ` de ${nomeDaPessoa}` : ''}
      </button>
    </div>
  );
}
